export const channelTextMap = (formatMessage: (id: { id: string }) => any) => {
  return {
    security: formatMessage({ id: 'Security' }),
    social: formatMessage({ id: 'Social Media' }),
    comments: formatMessage({ id: 'Game Store' }),
    news: formatMessage({ id: 'News Media' }),
  };
};

export const channelSplitFlag: string = '#_#';

export const channelText: { [key: string]: { en: string; zh: string } } = {
  security: {
    zh: 'Security',
    en: 'Security',
  },
  comments: {
    zh: '游戏商店',
    en: 'Game Store',
  },
  social: {
    zh: '社交媒体',
    en: 'Social Media',
  },
  news: {
    zh: '新闻资讯',
    en: 'News Media',
  },
};

export const channelLocale = {
  en: {
    region_title: 'Channel',
    market_title: 'Channel',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Channel',
    button_market: 'Channel',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    region_title: '渠道',
    market_title: '渠道',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '渠道',
    button_market: '渠道',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};
